import { Button } from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import PageContainer from "components/PageContainer"
import { breakpoints } from "utils/createBreakpoints"

type Props = {
  onPrev?: () => void
  onNext?: () => void
  disabledNext: boolean
  disabledPrev: boolean
}

const BottomNavigation = ({
  onNext,
  onPrev,
  disabledNext,
  disabledPrev,
}: Props) => {
  const isBelowMd = useMediaQuery(breakpoints.down("sm"))

  return (
    <div className="fixed bottom-0 left-0 z-[6] w-full">
      <PageContainer fullWidth={isBelowMd}>
        <div className="flex justify-between rounded-t-2xl bg-onSurface-900 px-2 py-1.25 md:px-3 md:py-2">
          <Button
            onClick={onPrev}
            disabled={!onPrev || disabledPrev}
            size="xs"
            className="md:hidden"
          >
            Previous
          </Button>
          <Button
            onClick={onPrev}
            disabled={!onPrev || disabledPrev}
            size="md"
            className="hidden md:inline-flex"
          >
            Previous
          </Button>
          <Button
            onClick={onNext}
            disabled={!onNext || disabledNext}
            size="xs"
            className="md:hidden"
          >
            Next
          </Button>
          <Button
            onClick={onNext}
            disabled={!onNext || disabledNext}
            size="md"
            className="hidden md:inline-flex"
          >
            Next
          </Button>
        </div>
      </PageContainer>
    </div>
  )
}

export default BottomNavigation
